import * as React from "react";
import { storyblokEditable } from "gatsby-source-storyblok";
import { Href } from "../utils/helper";

const AdBannerImage = ({ blok }) => {

  const gridSize = {
    'full': 'md:col-span-12',
    'one-third': 'md:col-span-4',
    'three-fourth': 'md:col-span-9',
    'one-half': 'col-span-3 md:col-span-6',
    'one-fourth': 'col-span-3',
  }

  return (
    <div {...storyblokEditable(blok)} className={`${gridSize[blok.size]}`}>
      <a href={Href(blok.link)} title={blok.adTitle}>
        <img className={`w-full h-auto rounded-md`} loading="lazy" src={blok.adImage.filename} alt={blok.adImage.alt}/>
      </a>
    </div>
  );
};

export default AdBannerImage;